import { useTranslation } from 'react-i18next';
import useAttendanceProofGroup from './AttendanceProofGroup.hook';
import FormGroup from 'components/FormGroup';
import { CommonGroups } from 'modules/events/basics/enums/commonForms.enums';
import InformativeTooltip from 'modules/events/components/InformativeTooltip';
import Alert from 'yoda-ui/components/Alert';
import Box from 'yoda-ui/components/Box';
import CheckBoxYoda from 'yoda-ui/components/Form/CheckBoxYoda';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const AttendanceProofGroup = () => {
  const { t } = useTranslation();
  const { config, showRetroactiveWarning, handleSignatureCollectionChange } = useAttendanceProofGroup();

  return (
    <FormGroup title={ t('attendanceProofGroup_title') } groupName={ CommonGroups.attendanceProof }>
      <Box marginBottom={ YodaSpacing.large } display="flex" alignItems="center">
        <CheckBoxYoda
          label={ config.qrCodeRegistration.label }
          name={ config.qrCodeRegistration.name }
          checked={ config.qrCodeRegistration.checked }
          disabled={ config.qrCodeRegistration.disabled }
        />
        <InformativeTooltip title={ config.qrCodeRegistration.tooltip } />
      </Box>
      {
        !config.signatureCollection.hidden && (
          <>
            <Box marginBottom={ YodaSpacing.large } display="flex" alignItems="center">
              <CheckBoxYoda
                label={ config.signatureCollection.label }
                name={ config.signatureCollection.name }
                checked={ config.signatureCollection.checked }
                disabled={ config.signatureCollection.disabled }
                onChange={ handleSignatureCollectionChange }
              />
              <InformativeTooltip title={ config.signatureCollection.tooltip } />
            </Box>
            {
              showRetroactiveWarning && (
                <Box marginBottom={ YodaSpacing.large }>
                  <Alert severity="warning">
                    { t('attendanceProofGroup_signature_retroactive_warning') }
                  </Alert>
                </Box>
              )
            }
          </>
        )
      }
    </FormGroup>
  );
};

export default AttendanceProofGroup;
